<template>
  <div class="layout">
    <Layout>
      <Header>
        <Navbar/>
      </Header>
      <Layout>
        <Layout :style="{padding: '0 44px 24px'}">
          <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
             <Post />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue"
export default {
  name: "Home",
  components: {
    Navbar,
  },
  created() {
  }
}
</script>
<style>
.ivu-layout-header {
  background:#2a2b2d !important;
}
</style>
